/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material



/* ========== ~~~~~~~~~~ CTA : ANALYTICS ~~~~~~~~~~ ========== */
class AnalyticsCTA extends Component {
  constructor(props) {
    super(props);
    this.state = { processing: false };
  }
  componentDidUpdate(prevProps) {
    if (!this.props.modalVisible && prevProps.modalVisible) {
        this.setState({ processing: false })
    }
  }
  // currentPageChanged = (prevProps) => !this.props.currentPage && prevProps.currentPage;
  render() {
    return(
      <Link
             type={'action_route'}
             text={`View Analytics`}
             color={this.props.color ? this.props.color : `primary`}
             action={() => this.props.viewAnalytics(this.props.embedUUID)}
             name={`viewanalytics`}
             icon={`chart-bar`}
             handleClick={() => this.setState({ processing: true })}
             operation={`load`}
             processing={this.state.processing}
      />
    );
  }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AnalyticsCTA;
